import { render, staticRenderFns } from "./workflowSettings.vue?vue&type=template&id=112adba9&scoped=true"
import script from "./workflowSettings.vue?vue&type=script&lang=js"
export * from "./workflowSettings.vue?vue&type=script&lang=js"
import style0 from "./workflowSettings.vue?vue&type=style&index=0&id=112adba9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112adba9",
  null
  
)

export default component.exports